import Vue from 'vue';
import axios from 'axios';
// import Cart from './cart';

const targetClass = 'add-to-cart-block';

const AddToCart = {
	Init() {
		/* eslint-disable */
		var targets = document.getElementsByClassName(targetClass);
		Array.prototype.forEach.call(targets, target => {
			new Vue({
				el: target,
				data: {
					appModel: []
				},
				methods: {
					addToCart(campaignItem) {
						axios
							.post('/Educational-Materials/Add', campaignItem)
							.then(response => {
								const ci = this.appModel.find(ci => ci.Id == campaignItem.Id);
								ci.Added = true;
								setTimeout(() => {
									ci.Added = false;
									ci.Availability.forEach(availability => {
										availability.Quantity = 0;
									});
								}, 5000);
							})
							.catch(error => {
								// console.log(error);
							})
							.then(() => {
								this.loading = false;
							});
					},
					quantityFocused(event) {
						event.target.select();
					}
				},
				created() {
					axios
						.get('/Educational-Materials/Campaign-Items', {
							params: {
								campaignItemIds: target.getAttribute('data-items')
							}
						})
						.then(response => {
							this.appModel = response.data;
						})
						.catch(error => {
							// console.log(error);
						})
						.then(() => {
							this.loading = false;
						});
				}
			});
		});
		/* eslint-enable */
	}
};

export default AddToCart;
